/**
 * Event / session location helpers (location_name + location_address).
 */

/**
 * @param {{ location_name?: string | null, location_address?: string | null, location?: string | null }} source
 * @returns {string}
 */
export function formatEventLocationDisplay(source) {
  if (!source) return '';
  const name = (source.location_name ?? source.location ?? '').trim();
  const address = (source.location_address ?? '').trim();
  if (name && address) return `${name} — ${address}`;
  return name || address || '';
}

/** Short label for landing pills — name or format only, never raw URLs. */
export function formatEventLocationLabel(source) {
  if (!source) return '';
  const name = (source.location_name ?? source.location ?? '').trim();
  if (name) return name;
  const format = (source.format ?? source.event_format ?? '').toLowerCase();
  if (format === 'online') return 'Online';
  if (format === 'in_person' || format === 'in-person') return 'In-Person';
  if (format === 'hybrid') return 'Hybrid';
  return '';
}

/**
 * Labels and placeholders for editor fields based on event format.
 * @param {string} [format] - events.format: online | in_person | hybrid
 */
export function getEventLocationFieldLabels(format) {
  const isOnline = format === 'online';
  if (isOnline) {
    return {
      nameLabel: 'Platform',
      namePlaceholder: 'e.g. Zoom, Google Meet, Webex',
      addressLabel: 'Meeting URL',
      addressPlaceholder: 'e.g. https://zoom.us/j/...',
    };
  }
  return {
    nameLabel: 'Venue Name',
    namePlaceholder: 'e.g. Marriott Downtown',
    addressLabel: 'Address',
    addressPlaceholder: 'e.g. 123 Main St, New York, NY 10001',
  };
}
